// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root___5yxi","notes":"Notes_notes__19sm1","note":"Notes_note__Dkw30","markdown":"Notes_markdown__3O0Aw"};